import { useState } from "react";
import { Checkbox } from "@/components/ui/checkbox";
import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";

// Searchable multi-select list. items: [{ id, label, sub?, hint?, muted? }]; selected: Set<string>.
export function CheckList({ items, selected, onToggle, emptyText = "Nothing to choose from.", searchPlaceholder = "Search…", testidPrefix = "checklist", maxHeight = "max-h-64" }) {
  const [q, setQ] = useState("");
  const needle = q.trim().toLowerCase();
  const shown = needle ? items.filter((it) => `${it.label} ${it.sub || ""}`.toLowerCase().includes(needle)) : items;
  return (
    <div className="space-y-2">
      {items.length > 6 && (
        <div className="relative">
          <Search className="h-3.5 w-3.5 text-slate-400 absolute left-2.5 top-2.5" />
          <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder={searchPlaceholder} className="h-8 pl-8 text-xs" data-testid={`${testidPrefix}-search`} />
        </div>
      )}
      <div className={`rounded-md border border-slate-200 divide-y divide-slate-100 overflow-y-auto ${maxHeight}`} data-testid={`${testidPrefix}-list`}>
        {items.length === 0 && <p className="px-3 py-4 text-xs text-slate-400 italic text-center">{emptyText}</p>}
        {items.length > 0 && shown.length === 0 && <p className="px-3 py-4 text-xs text-slate-400 italic text-center">No matches.</p>}
        {shown.map((it) => {
          const on = selected.has(it.id);
          return (
            <label key={it.id} className={`flex items-start gap-3 px-3 py-2 cursor-pointer hover:bg-slate-50 ${on ? "bg-blue-50/60" : ""}`} data-testid={`${testidPrefix}-item-${it.id}`}>
              <Checkbox checked={on} onCheckedChange={() => onToggle(it.id)} className="mt-0.5" data-testid={`${testidPrefix}-check-${it.id}`} />
              <span className="min-w-0 flex-1">
                <span className={`block text-sm font-medium whitespace-normal break-words ${it.muted ? "text-slate-400" : "text-slate-800"}`}>{it.label}</span>
                {it.sub && <span className="block text-[11px] text-slate-400 font-mono-data whitespace-normal break-words">{it.sub}</span>}
                {it.hint && <span className="block text-[10px] text-slate-400 mt-0.5 whitespace-normal break-words">{it.hint}</span>}
              </span>
            </label>
          );
        })}
      </div>
    </div>
  );
}
